export const DEFAULT_COUNT_ON_PAGE = 4;
